import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { QuicklinkSharedModule } from '@core/ngx-quicklink.shared.module';
import { CompanyLayoutComponent } from '@features/directories/company-layout/company-layout.component';
import { CompaniesComponent } from '@features/directories/company-layout/contents/companies/companies.component';
import { JobsCitiesComponent } from '@features/directories/job-layout/contents/jobs-cities/jobs-cities.component';
import { JobsDomainsComponent } from '@features/directories/job-layout/contents/jobs-domains/jobs-domains.component';
import { JobsComponent } from '@features/directories/job-layout/contents/jobs/jobs.component';
import { JobLayoutComponent } from '@features/directories/job-layout/job-layout.component';
import { LangEnum } from '@models/commons/locales.enum';
import { DirectoriesRoutingEnum } from '@routing/directories/directories-routing.enum';
import { JobsContractsComponent } from '@features/directories/job-layout/contents/jobs-contracts/jobs-contracts.component';

const routes: Routes = [
  {
    path: DirectoriesRoutingEnum.Entreprises,
    component: CompanyLayoutComponent,
    children: [
      {
        path: '',
        component: CompaniesComponent,
        pathMatch: 'full',
      },
      {
        path: DirectoriesRoutingEnum.Lettre,
        component: CompaniesComponent,
      },
      {
        path: DirectoriesRoutingEnum.LettrePage,
        component: CompaniesComponent,
      },
    ],
  },
  {
    path: DirectoriesRoutingEnum.Jobs,
    component: JobLayoutComponent,
    children: [
      {
        path: '',
        component: JobsComponent,
        pathMatch: 'full',
      },
      {
        path: DirectoriesRoutingEnum.Lettre,
        component: JobsComponent,
      },
      {
        path: DirectoriesRoutingEnum.LettrePage,
        component: JobsComponent,
      },
    ],
  },
  {
    path: DirectoriesRoutingEnum.Lp,
    component: JobLayoutComponent,
    children: [
      {
        path: '',
        data: {
          lang: LangEnum.fr,
        },
        children: [
          {
            path: DirectoriesRoutingEnum.VillesFR,
            component: JobsCitiesComponent,
          },
          {
            path: DirectoriesRoutingEnum.DomainesFR,
            component: JobsDomainsComponent,
          },
          {
            path: DirectoriesRoutingEnum.ContractsFR,
            component: JobsContractsComponent,
          },
        ],
      },
      {
        path: '',
        data: {
          lang: LangEnum.en,
        },
        children: [
          {
            path: DirectoriesRoutingEnum.VillesEN,
            component: JobsCitiesComponent,
          },
          {
            path: DirectoriesRoutingEnum.DomainesEN,
            component: JobsDomainsComponent,
          },
          {
            path: DirectoriesRoutingEnum.ContractsEN,
            component: JobsContractsComponent,
          },
        ],
      },
      {
        path: '',
        data: {
          lang: LangEnum.es,
        },
        children: [
          {
            path: DirectoriesRoutingEnum.VillesES,
            component: JobsCitiesComponent,
          },
          {
            path: DirectoriesRoutingEnum.DomainesES,
            component: JobsDomainsComponent,
          },
          {
            path: DirectoriesRoutingEnum.ContractsES,
            component: JobsContractsComponent,
          },
        ],
      },
      {
        path: '',
        data: {
          lang: LangEnum.it,
        },
        children: [
          {
            path: DirectoriesRoutingEnum.VillesIT,
            component: JobsCitiesComponent,
          },
          {
            path: DirectoriesRoutingEnum.DomainesIT,
            component: JobsDomainsComponent,
          },
          {
            path: DirectoriesRoutingEnum.ContractsIT,
            component: JobsContractsComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), QuicklinkSharedModule],
  exports: [RouterModule],
})
export class DirectoriesRoutingModule {}
